(ns admin.db.configuration
  (:require [clojure.spec.alpha :as s]

            [kyber.constants :refer [base-api-url]]))

(def initial-state {:analytics-schema-version 0
                    :cognito-user-pool nil
                    :cognito-user-pool-id nil
                    :cognito-client-id nil
                    :custom-analytics nil
                    :kyber-base-url base-api-url})

(s/def :configuration/analytics-schema-version number?)
(s/def :configuration/cognito-user-pool (s/nilable any?))
(s/def :configuration/cognito-user-pool-id (s/nilable string?))
(s/def :configuration/cognito-client-id (s/nilable string?))
(s/def :configuration/custom-analytics (s/nilable map?))
(s/def :configuration/kyber-base-url (s/nilable string?))

(s/def ::configuration (s/keys :req-un [:configuration/analytics-schema-version
                                        :configuration/cognito-user-pool
                                        :configuration/cognito-user-pool-id
                                        :configuration/cognito-client-id
                                        :configuration/custom-analytics
                                        :configuration/kyber-base-url]))
